import React from "react";
import {
  CalendarClock,
  CalendarRange,
  CircleCheckBig,
  Clock,
  TriangleAlert,
} from "lucide-react";
import TransSummaryComp from "../helper-components/trans-summary-comp";

const LABEL_CLASS =
  "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]";
const VALUE_CLASS =
  "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2";
const CARD_CLASS = "rounded-[12px] h-[5.3rem] w-full p-3 flex justify-between";
const DESC_CLASS =
  "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)]";

// Same cards as the other list pages (TransSummaryComp); each is also a
// shortcut to the filters that list its follow-ups
const SUMMARY_CARDS = [
  {
    key: "pending",
    label: "Pending",
    desc: "Waiting for a follow-up",
    Icon: Clock,
    color: "var(--trans-stats-con-blue-fg)",
    conClass: `bg-[var(--trans-stats-con-blue-bg)] ${CARD_CLASS}`,
    descClass: `${DESC_CLASS} text-[var(--trans-stats-con-blue-fg)]`,
    filter: { status: "pending", due: "all" },
  },
  {
    key: "overdue",
    label: "Overdue",
    desc: "Refill date has passed",
    Icon: TriangleAlert,
    color: "var(--trans-stats-con-red-fg)",
    conClass: `bg-[var(--trans-stats-con-red-bg)] ${CARD_CLASS}`,
    descClass: `${DESC_CLASS} text-[var(--trans-stats-con-red-fg)]`,
    filter: { status: "pending", due: "overdue" },
  },
  {
    key: "due_today",
    label: "Due Today",
    desc: "Reach out today",
    Icon: CalendarClock,
    color: "var(--trans-stats-con-orange-fg)",
    conClass: `bg-[var(--trans-stats-con-orange-bg)] ${CARD_CLASS}`,
    descClass: `${DESC_CLASS} text-[var(--trans-stats-con-orange-fg)]`,
    filter: { status: "pending", due: "today" },
  },
  {
    key: "due_this_week",
    label: "Next 7 Days",
    desc: "Coming up soon",
    Icon: CalendarRange,
    color: "var(--trans-stats-con-voilet2-fg)",
    conClass: `bg-[var(--trans-stats-con-violet2-bg)] ${CARD_CLASS}`,
    descClass: `${DESC_CLASS} text-[var(--trans-stats-con-voilet2-fg)]`,
    filter: { status: "pending", due: "week" },
  },
  {
    key: "done",
    label: "Completed",
    desc: "Already followed up",
    Icon: CircleCheckBig,
    color: "var(--trans-stats-con-green-fg)",
    conClass: `bg-[var(--trans-stats-con-green-bg)] ${CARD_CLASS}`,
    descClass: `${DESC_CLASS} text-[var(--trans-stats-con-green-fg)]`,
    filter: { status: "done", due: "all" },
  },
];

const FollowUpSummaryCards = ({ summary, filters, onSelect }) => (
  <section
    aria-label="Follow-up summary"
    className="grid grid-cols-2 gap-5 px-[24px] pt-[16px] md:grid-cols-3 xl:grid-cols-5"
  >
    {SUMMARY_CARDS.map(({ key, label, desc, Icon, color, conClass, descClass, filter }) => {
      const isActive = filters.status === filter.status && filters.due === filter.due;
      return (
        <button
          key={key}
          type="button"
          aria-pressed={isActive}
          onClick={() => onSelect(filter)}
          className="rounded-[12px] text-left focus-visible:outline-none"
          // outlines paint over the card, so the selected one shows its colour
          style={{ outline: isActive ? `2px solid ${color}` : "none", outlineOffset: "-2px" }}
        >
          <TransSummaryComp
            sum={{
              conClass,
              label,
              labelClass: LABEL_CLASS,
              value: summary ? summary[key] ?? 0 : "–",
              valueClass: VALUE_CLASS,
              desc,
              descClass,
              icon: <Icon size={16} color={color} aria-hidden="true" />,
            }}
          />
        </button>
      );
    })}
  </section>
);

export default FollowUpSummaryCards;
